import React, { useState } from 'react';
import './ui.css';

export const DangerZone: React.FC<{ children: React.ReactNode; title?: string }> = ({
  children, title = 'Danger zone',
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`ui-danger${open ? ' ui-danger--open' : ''}`}>
      <button type="button" className="ui-danger__toggle" onClick={() => setOpen(!open)}>
        {title} {open ? '▴' : '▾'}
      </button>
      {open && <div className="ui-danger__body">{children}</div>}
    </div>
  );
};
